export const toType = (classz: any) => typeof classz;
